import { useState, useEffect } from 'react';
import { Button } from "@/components/ui/button";
import { db } from "@/lib/firebase";
import { collection, getDocs } from "firebase/firestore";
import { useNavigate } from 'react-router-dom';

const DebugFirebasePage = () => {
  const navigate = useNavigate();
  const [collections, setCollections] = useState<{[key: string]: {count: number, error?: string}}>({});
  const [loading, setLoading] = useState(false);
  
  const testCollections = async () => {
    setLoading(true);
    const collectionNames = ["locations", "soda-brands", "soda-flavors", "soda-attributes", "sightings"];
    const results: {[key: string]: {count: number, error?: string}} = {};
    
    for (const collName of collectionNames) {
      try {
        const collRef = collection(db, collName);
        const snapshot = await getDocs(collRef);
        results[collName] = { 
          count: snapshot.docs.length,
        };
        
        if (snapshot.docs.length > 0) {
          console.log(`Sample document from ${collName}:`, snapshot.docs[0].data());
        }
      } catch (err) {
        console.error(`Error accessing ${collName}:`, err);
        results[collName] = { 
          count: 0, 
          error: err instanceof Error ? err.message : 'Unknown error' 
        };
      }
    }
    
    setCollections(results);
    setLoading(false);
  };
  
  useEffect(() => {
    testCollections();
  }, []);
  
  return (
    <div className="container mx-auto p-4">
      <div className="flex justify-between items-center mb-6">
        <h1 className="text-2xl font-bold">Firebase Debug</h1>
        <Button onClick={() => navigate('/')}>Back to Home</Button>
      </div>
      
      <div className="mb-4 flex space-x-2">
        <Button 
          onClick={testCollections} 
          disabled={loading}
        >
          {loading ? "Testing..." : "Test Collection Access"}
        </Button>
      </div>
      
      <div className="bg-white p-4 rounded-lg shadow">
        <h2 className="text-xl font-semibold mb-4">Collection Status</h2>
        
        {Object.keys(collections).length === 0 && !loading ? (
          <p>No collection data yet. Click "Test Collection Access" to fetch.</p>
        ) : (
          <div className="space-y-4">
            {Object.entries(collections).map(([name, data]) => (
              <div key={name} className={`p-3 rounded-md ${data.error ? 'bg-red-100' : 'bg-green-100'}`}>
                <h3 className="font-medium">{name}</h3>
                <p>Document Count: {data.count}</p>
                {data.error && (
                  <p className="text-red-600 mt-1">{data.error}</p>
                )}
              </div>
            ))}
          </div>
        )}
      </div>
    </div>
  );
};

export default DebugFirebasePage; 